// Unpublished Work © 2024 Deere & Company.

export const JDF_APP_NAMES = ['Sales Center JDF - CSC2'];
